import styled from 'styled-components';

export const LevelsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 15px;
`;
